const CatalogThemesManager = () => import('@/components/SuperAdmin/CatalogThemes/CatalogThemesManager')

export default [
	{
		component: CatalogThemesManager,
		name: 'sa-catalog-themes',
		path: 'catalog-themes'
	}
]
